import Firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/firestore'
import 'firebase/storage'

const firebaseApp = Firebase.initializeApp({
  apiKey: 'AIzaSyC6gkOuekMKMAS6FxYq-X7JirxEveHRNyk',
  authDomain: 'mhckv4wz8lb18307ig6f.firebaseapp.com',
  databaseURL: 'https://mhckv4wz8lb18307ig6f.firebaseio.com',
  projectId: 'mhckv4wz8lb18307ig6f',
  storageBucket: 'mhckv4wz8lb18307ig6f.appspot.com',
  messagingSenderId: '356951179120',
  appId: '1:356951179120:web:478e5c01cda283cadf99b5'
})

const logs = Firebase.initializeApp({
  apiKey: 'AIzaSyC6gkOuekMKMAS6FxYq-X7JirxEveHRNyk',
  authDomain: 'mhckv4wz8lb18307ig6f.firebaseapp.com',
  databaseURL: 'https://logskne.firebaseio.com',
  projectId: 'mhckv4wz8lb18307ig6f',
  storageBucket: 'mhckv4wz8lb18307ig6f.appspot.com',
  messagingSenderId: '356951179120'
}, 'logs')

const archives = Firebase.initializeApp({
  apiKey: 'AIzaSyC6gkOuekMKMAS6FxYq-X7JirxEveHRNyk',
  authDomain: 'mhckv4wz8lb18307ig6f.firebaseapp.com',
  databaseURL: 'https://archivebma80-160.firebaseio.com',
  projectId: 'mhckv4wz8lb18307ig6f',
  storageBucket: 'mhckv4wz8lb18307ig6f.appspot.com',
  messagingSenderId: '356951179120'
}, 'archives')

const archives2 = Firebase.initializeApp({
  apiKey: 'AIzaSyC6gkOuekMKMAS6FxYq-X7JirxEveHRNyk',
  authDomain: 'mhckv4wz8lb18307ig6f.firebaseapp.com',
  databaseURL: 'https://currentarchivekne2021.firebaseio.com',
  projectId: 'mhckv4wz8lb18307ig6f',
  storageBucket: 'mhckv4wz8lb18307ig6f.appspot.com',
  messagingSenderId: '356951179120'
}, 'archives2')

const mapUrl = Firebase.initializeApp({
  apiKey: 'AIzaSyC6gkOuekMKMAS6FxYq-X7JirxEveHRNyk',
  authDomain: 'mhckv4wz8lb18307ig6f.firebaseapp.com',
  databaseURL: 'https://map-url-test.firebaseio.com',
  projectId: 'mhckv4wz8lb18307ig6f',
  storageBucket: 'mhckv4wz8lb18307ig6f.appspot.com',
  messagingSenderId: '356951179120'
}, 'mapUrl')
// // Export the database for components to use.
// // If you want to get fancy, use mixins or provide / inject to avoid redundant imports.

export const db = firebaseApp.database()
export const dbLogs = logs.database()
export const dbArchives = archives.database()
export const dbArchives2 = archives2.database()
export const dbMapUrl = mapUrl.database()

export const dbChats = firebaseApp.firestore()
export const storageRef = Firebase.storage().ref()
export const firebase = Firebase

export const usersRef = dbChats.collection('users')
export const roomsRef = dbChats.collection('chatRooms')

export const messagesRef = roomId => roomsRef.doc(roomId).collection('messages')
export const filesRef = storageRef.child('files')
export const dbTimestamp = Firebase.firestore.FieldValue.serverTimestamp()
export const deleteDbField = Firebase.firestore.FieldValue.delete()

